import { render, staticRenderFns } from "./ParticipantIdentification.vue?vue&type=template&id=77394fc8&scoped=true&"
import script from "./ParticipantIdentification.ts?vue&type=script&lang=ts&"
export * from "./ParticipantIdentification.ts?vue&type=script&lang=ts&"
import style0 from "./ParticipantIdentification.scss?vue&type=style&index=0&id=77394fc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77394fc8",
  null
  
)

export default component.exports